import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_ALL_PROVIDER_EXPORT_LIST = 'GET_ALL_PROVIDER_EXPORT_LIST';
export const GET_ALL_PROVIDER_EXPORT_LIST_SUCCESS =
  'GET_ALL_PROVIDER_EXPORT_LIST_SUCCESS';
export const GET_ALL_PROVIDER_EXPORT_LIST_FAILURE =
  'GET_ALL_PROVIDER_EXPORT_LIST_FAILURE';

// Action Creators
export const fetchGetAllProviderExportList = () => ({
  type: GET_ALL_PROVIDER_EXPORT_LIST,
});

export const fetchGetAllProviderExportListSuccess = (data) => ({
  type: GET_ALL_PROVIDER_EXPORT_LIST_SUCCESS,
  payload: data,
});

export const fetchGetAllProviderExportListFailure = (error) => ({
  type: GET_ALL_PROVIDER_EXPORT_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getAllProviderExportListCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetAllProviderExportList(data, external));
    try {
      const response = await getMethodWithToken(
        url.getAllProviderExportListSuperAdmin + '?type=download'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetAllProviderExportListSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetAllProviderExportListFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetAllProviderExportListFailure(error.message));
    }
  };
};
